import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Spinner from '../ogComponent/spinner';
import { IconPlus } from '@tabler/icons-react';

export default function Shifts() {
    const [shifts, setShifts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const navigate = useNavigate();

    // Access permissions array from Redux store
    const permissions = useSelector((state) => state.emp.permissions);

    const pagePermissions = ["showshiftsID", "addshiftsID"];

    useEffect(() => {
        // Only fetch shifts if showshiftsID is in permissions
        if (permissions.includes("showshiftsID")) {
            const fetchShifts = async () => {
                const token = localStorage.getItem("accessToken");
                if (!token) {
                    setError('No token found');
                    setLoading(false);
                    return;
                }

                try {
                    const response = await axios.get(`${process.env.REACT_APP_API}/api/employee/shifts/`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });

                    setShifts(response.data);
                    setLoading(false);
                } catch (err) {
                    console.error("Error fetching shifts data:", err);
                    setError('Error fetching shifts data');
                    setLoading(false);
                }
            };

            fetchShifts();
        } else {
            setLoading(false); // Skip loading if no permission
        }
    }, [permissions]);

    const handleCardClick = (id) => {
        console.log(`Shift ${id} clicked`);
        navigate(`/user/shift/${id}`);
    };

    return (
        <div className='container-fluid px-3 px-md-4 d-flex flex-column gap-3'>
            <div className="d-flex justify-content-start align-items-start flex-column mt-3 mb-1">
                {permissions.includes("showshiftsID") && (
                    <div>
                        <h3 className="fw-light mb-0">Shifts</h3>
                        <p
                            className="align-self-start mb-2"
                            style={{ color: "grey", fontSize: "clamp(10px, 1.1vw, 12px)", fontWeight: '600' }}
                        >
                            Total {shifts.length} Shift{shifts.length !== 1 ? "s" : ""}
                        </p>
                    </div>
                )}
                {permissions.includes("addshiftsID") && (
                    <Link
                        to={'/user/functions?tabId=3'}
                        className="btn btn-success d-flex justify-content-center align-items-center"
                        style={{ height: '35px' }}
                    >
                        <IconPlus stroke={2} size={20} /> New shift
                    </Link>
                )}
            </div>

            {loading ? (
                <Spinner />
            ) : error ? (
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "50vh" }}
                >
                    <p className="text-danger">Error loading shifts data</p>
                </div>
            ) : permissions.includes("showshiftsID") ? (
                shifts.length === 0 ? (
                    <div
                        className="d-flex justify-content-center align-items-end position-relative"
                        style={{ height: "50vh" }}
                    >
                        <div
                            className="position-absolute top-0 start-0 w-100 h-100"
                            style={{
                                backgroundImage: "url(/assets/file.png)",
                                backgroundSize: "contain",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                                opacity: 0.3,
                            }}
                        ></div>
                        <p className="m-0 fw-light fs-5 position-relative">No Shifts!</p>
                    </div>
                ) : (
                    <div className="row">
                        {shifts.map((item) => (
                            <div
                                key={item.id}
                                className="col-12 col-sm-6 col-md-6 col-lg-4 mb-3"
                                style={{ cursor: "pointer", minWidth: "270px" }}
                                onClick={() => handleCardClick(item.id)}
                            >
                                <div className="card h-100 px-3">
                                    <div className="card-body d-flex flex-column py-2 px-0">
                                        <div className="p-2">
                                            <h6
                                                className="card-title text-capitalize"
                                                style={{
                                                    fontSize: "clamp(12px, 1.3vw, 17px)",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    width: "100%",
                                                }}
                                            >
                                                {item.shift_name} - {item.shift_type || "N/A"}
                                            </h6>
                                        </div>
                                        <div
                                            className="rounded-3 px-3 py-2 mb-2"
                                            style={{
                                                backgroundColor: "#f8f7f7",
                                                fontSize: "clamp(12px, 1.2vw, 14px)",
                                            }}
                                        >
                                            <table>
                                                <tr>
                                                    <td className='ps-0'><i className="bi bi-clock me-2"></i>Start Time</td>
                                                    <td><span className='me-4'>:</span>{item.start_time || "N/A"}</td>
                                                </tr>
                                                <tr>
                                                    <td className='ps-0'><i className="bi bi-clock me-2"></i>End Time</td>
                                                    <td><span className='me-4'>:</span>{item.end_time || "N/A"}</td>
                                                </tr>
                                                <tr>
                                                    <td className='ps-0'><i className="bi bi-clock me-2"></i>Work Hour</td>
                                                    <td><span className='me-4'>:</span>{item.working_hours || "N/A"}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )
            ) : (
                <div
                    className="d-flex justify-content-center align-items-end position-relative"
                    style={{ height: "50vh" }}
                >
                    <p className="m-0 fw-light fs-5 position-relative">No permission to view shifts.</p>
                </div>
            )}
        </div>
    );
}